export default __webpack_public_path__ + "static/productosdelujo-logo-2a7752cb2fb1794b4a5966cc2aa1ad74.png";